import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_SERVER_URL,
    timeout: 3600000,
    headers: {
        'Authorization': "Bearer " + localStorage.getItem('access_token'),
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
});

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRefreshed(newToken) {
  refreshSubscribers.forEach(cb => cb(newToken));
  refreshSubscribers = [];
}

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        const refresh_token = localStorage.getItem('refresh_token');

        const status = error?.response?.status;
        const { MESSAGE: message, DETAIL: detail} = error.response.data;

        if (
            status === 401 &&
            message && (
                detail.toLowerCase().includes("signature has expired") ||
                detail.toLowerCase().includes("token has expired") ||
                detail.toLowerCase().includes("token has been revoked") ||
                detail.toLowerCase().includes("invalid signature")
            ) &&
            refresh_token &&
            !originalRequest._retry
        ) {
            console.log("Trying to refresh the token.")
            originalRequest._retry = true;
            if (isRefreshing) {
                // If refresh is already in progress, queue this request
                return new Promise(resolve => {
                    subscribeTokenRefresh(token => {
                        originalRequest.headers['Authorization'] = 'Bearer ' + token;
                        resolve(axiosInstance(originalRequest));
                    });
                });
            }

            isRefreshing = true;

            try {
                const refreshResponse = await axiosInstance.post('/refresh', {}, {
                    headers: { Authorization: 'Bearer ' + refresh_token },
                });

                const newAccessToken = refreshResponse.data.access_token;

                localStorage.setItem('access_token', newAccessToken);
                axiosInstance.defaults.headers['Authorization'] = 'Bearer ' + newAccessToken;
                
                onRefreshed(newAccessToken);
                isRefreshing = false;

                originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;
                return axiosInstance(originalRequest);

            } catch (refreshError) {
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                delete axiosInstance.defaults.headers['Authorization'];

                isRefreshing = false;
                window.location.href = '/#/login';
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
